export default "__VITE_ASSET__Cwy92t4c__"